import React from "react";
import "../../css/footer.css";
import Box from "@mui/joy/Box";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab, { tabClasses } from "@mui/joy/Tab";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import Typography from "@mui/joy/Typography";
import ForestIcon from "@mui/icons-material/Forest";
import MapIcon from "@mui/icons-material/Map";
import HandshakeIcon from "@mui/icons-material/Handshake";
import PersonIcon from "@mui/icons-material/Person";
import Link from "@mui/joy/Link";

export default function FooterMenu() {
  return (
    <Box
      className="menufooter"
      sx={{
        flexGrow: 1,
        p: 4,
        display: "flex",
        justifyItems: "center",
        alignContent: "center",
        justifyContent: "center",
        margin: 0,
        padding: 0,
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        zIndex: 1000,
      }}
    >
      <Tabs
        size="lg"
        aria-label="Bottom Navigation"
        sx={(theme) => ({
          p: 1,
          maxWidth: "100%",
          mx: "auto",
          boxShadow: theme.shadow.sm,
        })}
      >
        <TabList
          variant="plain"
          size="sm"
          disableUnderline
          sx={{ borderRadius: "lg", p: 0 }}
        >
          <Tab
            disableRipple
            disableIndicator
            value="0"
            orientation="vertical"
            sx={{
              "&.Mui-selected": {
                "& svg": { color: "inherit" }, // Cambia 'orange' al color que prefieras
              },
            }}
          >
            <ListItemDecorator>
              <Link color="inherit" href="/">
                {" "}
                <HomeRoundedIcon sx={{ color: "inherit" }} />
              </Link>
            </ListItemDecorator>
            <Typography level="body-xs">Inicio</Typography>
          </Tab>
          <Tab
            disableIndicator
            disableRipple
            orientation="vertical"
            sx={{
              "&.Mui-selected": {
                "& svg": { color: "inherit" }, // Cambia 'orange' al color que prefieras
              },
            }}
          >
            <ListItemDecorator>
              <Link color="inherit" href="/aventuras">
                <ForestIcon sx={{ color: "inherit" }} />
              </Link>
            </ListItemDecorator>
            <Typography level="body-xs">Aventuras</Typography>
          </Tab>
          <Tab
            disableRipple
            disableIndicator
            orientation="vertical"
            sx={{
              "&.Mui-selected": {
                "& svg": { color: "inherit" }, // Cambia 'orange' al color que prefieras
              },
            }}
          >
            <ListItemDecorator>
              <Link color="inherit" href="/crear-aventura">
                <MapIcon sx={{ color: "inherit" }} />
              </Link>
            </ListItemDecorator>
            <Typography level="body-xs">Planificar</Typography>
          </Tab>
          <Tab
            disableRipple
            disableIndicator
            orientation="vertical"
            sx={{
              "&.Mui-selected": {
                "& svg": { color: "inherit" }, // Cambia 'orange' al color que prefieras
              },
            }}
          >
            <ListItemDecorator>
              <Link color="inherit" href="/amigos">
                <HandshakeIcon sx={{ color: "inherit" }} />
              </Link>
            </ListItemDecorator>
            <Typography level="body-xs">Amigos</Typography>
          </Tab>
          <Tab
            disableRipple
            disableIndicator
            orientation="vertical"
            sx={{
              "&.Mui-selected": {
                "& svg": { color: "inherit" }, // Cambia 'orange' al color que prefieras
              },
            }}
          >
            <ListItemDecorator>
              <Link color="inherit" href="/cuenta">
                <PersonIcon sx={{ color: "inherit" }} />
              </Link>
            </ListItemDecorator>
            <Typography level="body-xs">Perfil</Typography>
          </Tab>
        </TabList>
      </Tabs>
    </Box>
  );
}
